<script lang="ts" setup>
    import { defineProps, defineEmits } from 'vue';
    import { Group } from './Groups.access';

    const props = defineProps<{
        group: Group;
        index: number;
    }>();

    const emit = defineEmits(['select']);

    const select = () => {
        emit('select', props.group.GroupId);
    };
</script>

<template>
    <div class="flex-1" style="min-width: min(400px, 100%)">
        <h4 class="d-flex flex-wrap gap-xs align-items-baseline">
            <div class="link-primary" @click="select">
                {{ props.group.Name }}
            </div>
        </h4>

        <strong>{{ $Resources.AclGroupTableUsers }}:</strong>
        {{ props.group.UserCount }} |
        <strong>{{ $Resources.AclGroupTableObjects }}:</strong>
        {{ props.group.ObjectCount }}
    </div>
</template>
